<template>
  <div class="group flex items-center gap-2">
    <!-- Hidden Native Radio Input -->
    <input
      type="radio"
      class="peer hidden"
      :id="id"
      :name="name"
      :value="value"
      :checked="modelValue === value"
      @change="$emit('update:modelValue', value)"
      :disabled="disabled"
    />

    <!-- Custom Radio Button -->
    <div
      class="flex w-full md:w-80 cursor-pointer items-center gap-2 rounded-[4px] bg-white px-[10px] py-[10px] sm:py-[5px] ring-1 ring-gray hover:bg-dark-turquoise-10 hover:text-dark-turquoise hover:ring-dark-turquoise peer-checked:bg-dark-turquoise-10 peer-checked:text-black peer-checked:ring-dark-turquoise text-b2"
      @click="!disabled && $emit('update:modelValue', value)"
      tabindex="0"
      @keyup.enter="!disabled && $emit('update:modelValue', value)"
      :aria-checked="modelValue === value"
      role="radio"
      :aria-labelledby="`label-${id}`"
    >

        <span v-if="modelValue === value" class="relative">
          <span class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 block w-[6px] h-[6px] rounded-[6px] bg-[#007893]"></span>
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="17" height="17" rx="8.5" fill="white" stroke="#007893"/>
          </svg>
        </span>
        <span v-else>
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.5" y="0.5" width="17" height="17" rx="8.5" fill="white" stroke="#5E5E5E"/>
            </svg>
        </span>

      <!-- Label -->
      <span class="pl-[3px]">{{ label }}</span>
    </div>


  </div>
</template>

<script>
export default {
  name: 'RadioButton',
  props: {
    modelValue: [String, Number, Boolean],
    id: { type: String, required: true },
    name: { type: String, required: true }, // Radios in the same group should have the same name
    value: { type: [String, Number, Boolean], required: true },
    label: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    preset: { type: Boolean, default: false },
    size: {
      type: String,
      default: 'md',
      validator: (value) => ['sm', 'md', 'lg'].includes(value),
    },
    customIcon: { type: String, default: '' },
  },
  emits: ['update:modelValue'],

  created() {
    if(this.preset == true) this.$emit('update:modelValue', this.preset)
  },
};
</script>
